module.exports = __webpack_public_path__ + "img/payment-method-banner.4350ebc5.png";